import styled, { css } from 'styled-components';

/** نجوم/أشرطة التقييم — لون نجوم البطاقات والشارات (هوية المشروع) */
const BRAND_STAR = 'oklch(0.65 0.24 33.09)';
/** تعبئة شريط التوزيع = نفس لون النجوم */
const BRAND_BAR = BRAND_STAR;
const BAR_EMPTY = 'oklch(0.92 0.012 255)';

/** نفس منطق DeliveryApps: عرض، اتجاه، عناوين */
export const Section = styled.section<{ $embedded?: boolean }>`
  max-width: ${(p) => (p.$embedded ? '100%' : '1200px')};
  width: ${(p) => (p.$embedded ? '100%' : '95%')};
  margin: ${(p) => (p.$embedded ? '16px 0 20px' : '24px auto 24px')};
  direction: rtl;
  flex-shrink: 0;

  @media (max-width: 768px) {
    width: ${(p) => (p.$embedded ? '100%' : '90%')};
  }
`;

/** $centerHeader: توسيط العنوان والوصف؛ عرض المستوى نفسه قدر صفحات الموقع */
export const Header = styled.div<{ $centerHeader?: boolean }>`
  margin-bottom: 12px;
  width: 100%;
  max-width: 100%;
  box-sizing: border-box;

  ${(p) =>
    p.$centerHeader &&
    css`
      display: flex;
      flex-direction: column;
      align-items: center;
      text-align: center;
    `}
`;

export const Title = styled.p<{ $centerHeader?: boolean }>`
  display: flex;
  align-items: center;
  gap: 10px;
  margin: 0 0 3px 0;
  color: #000000;
  font-size: 14px;
  font-weight: 700;
  line-height: 1.2;
  width: ${(p) => (p.$centerHeader ? '100%' : 'auto')};

  ${(p) =>
    p.$centerHeader
      ? css`
          justify-content: center;
          &::before,
          &::after {
            content: '';
            flex: 1 1 0;
            min-width: 12px;
            max-width: 160px;
            height: 1px;
            background: oklch(0.9288 0.0126 255.51);
            margin-top: 1px;
          }
        `
      : css`
          &::after {
            content: '';
            flex: 1;
            height: 1px;
            background: oklch(0.9288 0.0126 255.51);
            margin-top: 1px;
          }
        `}
`;

export const Subtitle = styled.p<{ $centerHeader?: boolean }>`
  margin: 0;
  font-size: 12px;
  font-weight: 400;
  color: oklch(0.68 0.03 257);
  padding-right: ${(p) => (p.$centerHeader ? '0' : '2px')};
  padding-left: ${(p) => (p.$centerHeader ? '0' : '0')};
  max-width: ${(p) => (p.$centerHeader ? 'min(520px, 100%)' : 'none')};

  ${(p) =>
    p.$centerHeader &&
    css`
      text-align: center;
    `}
`;

/** لوحة: توزيع النجوم + الملخّص — بعرض حاوية العنوان (دون توسيع Section عن الموقع) */
export const ReviewsDashboard = styled.div<{ $embedded?: boolean }>`
  margin-top: ${(p) => (p.$embedded ? 8 : 14)}px;
  box-sizing: border-box;
  width: 100%;
  max-width: 100%;
  align-self: stretch;
  display: grid;
  grid-template-columns: ${(p) => (p.$embedded ? '1fr' : 'minmax(0, 0.95fr) minmax(0, 1.05fr)')};
  gap: ${(p) => (p.$embedded ? 16 : 22)}px;
  align-items: start;
  padding: ${(p) => (p.$embedded ? '12px' : '16px 18px')};
  background: #fff;
  border: 1px solid oklch(0.93 0.01 255);
  border-radius: 14px;

  /* جوال: عمودان (ملخّص | أشرطة) — المودال يبقى عموداً واحداً */
  @media (max-width: 600px) {
    ${(p) =>
      p.$embedded
        ? css`
            grid-template-columns: 1fr;
            gap: 12px;
          `
        : css`
            grid-template-columns: minmax(0, 0.9fr) minmax(0, 1.1fr);
            gap: 8px 10px;
            padding: 12px 10px;
            align-items: start;
          `}
  }
`;

export const DashboardSummary = styled.div<{ $embedded?: boolean }>`
  display: flex;
  flex-direction: column;
  align-items: center;
  text-align: center;
  gap: 4px;
  padding: ${(p) => (p.$embedded ? '2px 0' : '6px 4px')};
  min-width: 0;
  order: 0;
`;

export const SummaryScore = styled.span<{ $embedded?: boolean }>`
  font-size: ${(p) => (p.$embedded ? '1.9rem' : '2.35rem')};
  font-weight: 800;
  color: #1a1a1a;
  font-variant-numeric: tabular-nums;
  line-height: 1.1;
  letter-spacing: -0.03em;
  margin-top: 2px;

  @media (max-width: 600px) {
    ${(p) =>
      !p.$embedded &&
      css`
        font-size: 1.75rem;
      `}
  }
`;

export const SummaryBasedOn = styled.p<{ $embedded?: boolean }>`
  margin: 0;
  font-size: ${(p) => (p.$embedded ? '12px' : '13px')};
  color: oklch(0.5 0.02 255);
  font-weight: 500;
  line-height: 1.35;

  @media (max-width: 600px) {
    ${(p) =>
      !p.$embedded &&
      css`
        font-size: 11px;
      `}
  }
`;

export const RecommendRow = styled.div<{ $embedded?: boolean }>`
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: center;
  flex-wrap: wrap;
  gap: 6px 8px;
  margin-top: ${(p) => (p.$embedded ? 8 : 10)}px;
  padding-top: ${(p) => (p.$embedded ? 8 : 10)}px;
  border-top: 1px solid oklch(0.94 0.01 255);
  width: 100%;

  @media (max-width: 600px) {
    ${(p) =>
      !p.$embedded &&
      css`
        margin-top: 6px;
        padding-top: 6px;
        gap: 4px 6px;
      `}
  }
`;

export const RecommendPct = styled.span<{ $embedded?: boolean }>`
  font-size: ${(p) => (p.$embedded ? '1.1rem' : '1.35rem')};
  font-weight: 800;
  color: #1a1a1a;
  font-variant-numeric: tabular-nums;
  direction: ltr;
`;

export const RecommendLabel = styled.span<{ $embedded?: boolean }>`
  font-size: ${(p) => (p.$embedded ? '12px' : '13px')};
  font-weight: 600;
  color: oklch(0.4 0.02 255);
`;

export const DashboardDist = styled.div`
  display: flex;
  flex-direction: column;
  gap: 6px;
  min-width: 0;
  width: 100%;
  order: 1;
`;

export const DistRow = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  direction: rtl;
  gap: 8px;
  min-height: 22px;

  @media (max-width: 600px) {
    gap: 5px;
    min-height: 20px;
  }
`;

export const DistStarNum = styled.span`
  font-size: 12px;
  font-weight: 700;
  color: #1a1a1a;
  min-width: 10px;
  text-align: center;
  font-variant-numeric: tabular-nums;
`;

export const DistStarIcon = styled.span`
  display: flex;
  color: ${BRAND_STAR};
  flex-shrink: 0;
  align-items: center;
`;

export const DistTrack = styled.div`
  flex: 1;
  min-width: 0;
  height: 8px;
  border-radius: 9999px;
  background: ${BAR_EMPTY};
  overflow: hidden;
`;

export const DistFill = styled.div<{ $pct: number }>`
  height: 100%;
  width: ${(p) => Math.max(0, Math.min(100, p.$pct))}%;
  border-radius: 9999px;
  background: ${BRAND_BAR};
  transition: width 0.45s ease;
`;

export const DistPct = styled.span`
  font-size: 11px;
  font-weight: 600;
  color: oklch(0.45 0.02 255);
  min-width: 32px;
  text-align: left;
  font-variant-numeric: tabular-nums;
  direction: ltr;

  @media (max-width: 600px) {
    font-size: 10px;
    min-width: 28px;
  }
`;

export const AggregateStarRow = styled.div<{
  $embedded?: boolean;
  $summary?: boolean;
}>`
  display: flex;
  flex-direction: row;
  align-items: center;
  gap: ${(p) =>
    p.$summary ? (p.$embedded ? 2 : 3) : p.$embedded ? 1 : 2}px;
  direction: ltr;
  flex-shrink: 0;
  margin-bottom: ${(p) => (p.$summary ? 2 : 0)}px;
`;

export const StarSlot = styled.span<{ $size: number }>`
  position: relative;
  display: inline-block;
  width: ${(p) => p.$size}px;
  height: ${(p) => p.$size}px;
  flex-shrink: 0;
`;

export const StarBack = styled.span`
  position: absolute;
  inset: 0;
  z-index: 0;
  display: flex;
  align-items: center;
  justify-content: center;
  color: oklch(0.88 0.02 95);
  pointer-events: none;
`;

export const StarFillClip = styled.span`
  position: absolute;
  left: 0;
  top: 0;
  z-index: 1;
  height: 100%;
  overflow: hidden;
  display: flex;
  align-items: center;
  justify-content: flex-start;
  max-width: 100%;
  pointer-events: none;
`;

/** حامل النجمة داخل القص — الملخّص: لون هوية المشروع */
export const StarFore = styled.span<{ $size: number; $summary?: boolean }>`
  display: flex;
  width: ${(p) => p.$size}px;
  min-width: ${(p) => p.$size}px;
  height: ${(p) => p.$size}px;
  flex-shrink: 0;
  align-items: center;
  justify-content: center;
  color: ${(p) => (p.$summary ? BRAND_STAR : '#e9a00c')};
  filter: drop-shadow(0 0.5px 0 oklch(0.5 0.1 60 / 0.2));
`;

export const List = styled.div`
  display: flex;
  flex-direction: column;
  gap: 8px;
`;

export const Card = styled.article`
  padding: 14px 16px;
  border-radius: 12px;
  background: #ffffff;
  border: 1px solid oklch(0.93 0.01 255);
`;

export const CardTop = styled.div`
  display: flex;
  align-items: flex-start;
  justify-content: space-between;
  gap: 10px;
  margin-bottom: 8px;
`;

/** صف: أفاتار + الاسم (اتجاه RTL من القسم) */
export const MetaRow = styled.div`
  display: flex;
  align-items: flex-start;
  gap: 10px;
  min-width: 0;
  flex: 1;
`;

/** دائرة أيقونة العميل — نفس تباينات البطاقات وعناوين الأقسام (DeliveryApps / Section Title) */
export const AvatarIconWrap = styled.div<{ $compact?: boolean }>`
  width: ${(p) => (p.$compact ? '36px' : '40px')};
  height: ${(p) => (p.$compact ? '36px' : '40px')};
  border-radius: 50%;
  flex-shrink: 0;
  display: flex;
  align-items: center;
  justify-content: center;
  background: oklch(0.9683 0.0069 247.9);
  border: 1px solid oklch(0.9288 0.0126 255.51);
  color: oklch(55.44% 0.041 257.42);

  svg {
    display: block;
  }
`;

export const Meta = styled.div`
  display: flex;
  flex-direction: column;
  gap: 2px;
  min-width: 0;
`;

export const CustomerName = styled.span`
  font-size: 13px;
  font-weight: 600;
  color: oklch(0.32 0.02 257);
`;

export const DateText = styled.span`
  font-size: 11px;
  color: oklch(0.68 0.03 257);
`;

/**
 * عمود: طفل واحد — justify-content: center يثبت التوسيط الرأسي داخل ارتفاع الـ pill
 * (أوثق من row + align-items عند اختلاف سلوك المتحكم في الرسم/RTL).
 */
export const RatingBadge = styled.div<{ $compact?: boolean }>`
  display: inline-flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  flex-shrink: 0;
  box-sizing: border-box;
  height: ${(p) => (p.$compact ? '20px' : '22px')};
  padding: 0 ${(p) => (p.$compact ? '7px' : '8px')};
  border-radius: 999px;
  background: oklch(0.97 0.025 55);
  border: 1px solid oklch(0.9 0.06 48);
  line-height: 1;
  unicode-bidi: isolate;
  min-height: 0;
  margin: 0;
`;

export const RatingBadgeInner = styled.div<{ $compact?: boolean }>`
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: center;
  flex: 0 0 auto;
  min-height: 0;
  margin: 0;
  padding: 0;
  column-gap: ${(p) => (p.$compact ? '3px' : '4px')};
  direction: ltr;

  & > svg {
    display: block;
    flex-shrink: 0;
  }
`;

/**
 * block + line-height = height: يتجنب bug يمدّ `display:flex` داخل الـ flex الأب
 * إلى min-height: auto (≈20px) في WebKit. بدون flex على هذا الـ span.
 */
export const RatingBadgeValue = styled.span<{ $compact?: boolean }>`
  display: block;
  flex: 0 0 auto;
  align-self: center;
  min-width: 0;
  direction: ltr;
  unicode-bidi: embed;
  text-align: center;
  /* مطابق لارتفاع أيقونة النجمة */
  height: ${(p) => (p.$compact ? '12px' : '13px')};
  line-height: ${(p) => (p.$compact ? '12px' : '13px')};
  font-size: ${(p) => (p.$compact ? '11px' : '12px')};
  font-weight: 600;
  font-family: inherit;
  font-variant-numeric: tabular-nums;
  color: oklch(0.42 0.14 33);
  -webkit-font-smoothing: antialiased;
`;

export const Comment = styled.p<{ $embedded?: boolean }>`
  margin: 0;
  font-size: 13px;
  line-height: 1.55;
  color: oklch(0.42 0.02 257);
  white-space: pre-wrap;
  word-break: break-word;

  ${(p) =>
    p.$embedded &&
    css`
      text-align: center;
    `}
`;


const shimmer = `
  @keyframes crShimmer {
    0% { background-position: -200% 0; }
    100% { background-position: 200% 0; }
  }
`;

export const SkeletonBase = styled.div`
  ${shimmer}
  background: linear-gradient(
    90deg,
    oklch(0.9683 0.0069 247.9) 0%,
    oklch(0.9288 0.0126 255.51) 20%,
    oklch(0.9683 0.0069 247.9) 40%,
    oklch(0.9683 0.0069 247.9) 100%
  );
  background-size: 200% 100%;
  animation: crShimmer 1.5s ease-in-out infinite;
  border-radius: 4px;
`;

export const SkeletonCard = styled.div`
  padding: 14px 16px;
  border-radius: 12px;
  background: #ffffff;
  border: 1px solid oklch(0.93 0.01 255);
`;

export const SkeletonLine = styled(SkeletonBase)<{ $w?: string; $h?: string }>`
  width: ${(p) => p.$w || '100%'};
  height: ${(p) => p.$h || '12px'};
`;

export const SkeletonAvatar = styled(SkeletonBase)<{ $compact?: boolean }>`
  width: ${(p) => (p.$compact ? '36px' : '40px')};
  height: ${(p) => (p.$compact ? '36px' : '40px')};
  border-radius: 50%;
  flex-shrink: 0;
`;

export const SkeletonMetaRow = styled.div`
  display: flex;
  align-items: flex-start;
  gap: 10px;
  margin-bottom: 10px;
`;

export const SkeletonMetaCol = styled.div`
  display: flex;
  flex-direction: column;
  gap: 6px;
  flex: 1;
  min-width: 0;
`;

export const LoadMoreButton = styled.button`
  display: block;
  width: 100%;
  box-sizing: border-box;
  margin: 10px 0 0;
  padding: 7px 16px;
  background-color: transparent;
  color: oklch(0.65 0.24 33.09);
  border: 1px solid oklch(0.65 0.24 33.09);
  border-radius: 10px;
  font-size: 13px;
  font-weight: 600;
  cursor: pointer;
  transition: all 0.2s;
  font-family: inherit;

  &:hover:not(:disabled) {
    background-color: oklch(0.65 0.24 33.09);
    color: #ffffff;
  }
  
  &:disabled {
    opacity: 0.6;
    cursor: not-allowed;
  }
`;
